import React from 'react';
import cx from 'classnames';

import { getFormInputClasses } from '../../utilities/form-helpers';

import Checkbox from './checkbox';
import FormInputLabel from './form-input-label';
import TranslatedCopy from '../../intl/translated-copy';

const FormInputCheckbox = ({
  checkboxLabelClassModifier,
  checkboxWrapperClassModifier,
  className,
  fieldLabel,
  fieldLabelCopyID,
  hasLabelTooltip,
  input: {
    name,
    onChange,
    value,
  },
  inputClassModifier,
  inputId,
  isDisabled,
  isHidden,
  isRequired,
  label,
  labelClassModifier,
  labelCopyID,
  meta: {
    error,
    touched,
    valid,
  },
  showOptionalLabel,
  showErrorMessage,
}) => {
  const isError = error && touched;
  const isValid = valid && value && touched;

  let inputDescribedBy = null;

  if (isError) {
    inputDescribedBy = `${name}-error-text`;
  }

  if (hasLabelTooltip) {
    const errorText = inputDescribedBy ? `${inputDescribedBy} ` : '';
    inputDescribedBy = `${errorText}${name}-tooltip`;
  }

  const formFieldClasses = cx({
    'FormInput-wrapper': true,
    'is-disabled': isDisabled,
    'is-error': isError,
    'is-correct': isValid,
    'has-fieldLabel': fieldLabel || fieldLabelCopyID,
  }, className);

  const labelClasses = cx({
    'FormInputCheckbox-label': true,
    'is-disabled': isDisabled,
  }, `FormInputCheckbox-label--${checkboxLabelClassModifier}`);

  /*
    <input> ID must start with an alphabetical character.
    Date.now() returns total time in milliseconds since 1970. So it's always unique.
    put the two together and you're golden.
  */
  const uniqueString = inputId || String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now();

  return (
    <div className={ getFormInputClasses(inputClassModifier, isHidden) }>
      <div className={ formFieldClasses } >
        { label || labelCopyID ?
          <FormInputLabel
            name={ name }
            isRequired={ isRequired }
            label={ label }
            labelClassModifier={ labelClassModifier }
            labelCopyID={ labelCopyID }
            showOptionalLabel={ showOptionalLabel } /> : null }
        <div className={ `FormInputCheckbox-wrapper FormInputCheckbox-wrapper--${checkboxWrapperClassModifier}` }>
          <Checkbox
            checked={ !!value }
            describedby={ inputDescribedBy }
            disabled={ isDisabled }
            id={ uniqueString }
            isError={ isError }
            name={ name }
            onChange={ (e, value) => onChange(e, value) }
            required={ isRequired }
            value={ value } />
          { fieldLabel || fieldLabelCopyID ? (
            <label
              className={ labelClasses }
              htmlFor={ uniqueString } >
              { fieldLabelCopyID ?
                <TranslatedCopy copyID={ fieldLabelCopyID } /> : fieldLabel }
            </label> ) : null }

          { isError && showErrorMessage && <div className='FormInputCheckbox--errorMessage'> <TranslatedCopy copyID={ error } /></div> }
        </div>
      </div>
    </div>
  );
};

FormInputCheckbox.defaultProps = {
  hasLabelTooltip: false,
  isDisabled: false,
  isHidden: false,
  isRequired: false,
  // Where FormInputCheckbox is used outside of the redux-form context,
  // sometimes no meta properties are passed down as props. Empty object
  // prevents errors on prop destructuring
  meta: {},
};

export default FormInputCheckbox;
